import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { useQuery } from 'glimmer-apollo';
import { NEWS_INDEX_QUERY } from 'embroil/gql/queries/news-index';

export default class NewsIndexRoute extends Route {
  @service head;

  queryParams = {
    page: {
      refreshModel: true
    }
  };

  async model(params) {
    const page = parseInt(params.page) || 1;
    const limit = 10;

    // Set canonical URL and robots meta for pagination
    const baseUrl = 'https://1vx.gg/news';
    if (page > 1) {
      this.head.updateMeta({
        canonical: baseUrl,
        robots: 'noindex,follow'
      });
    } else {
      this.head.updateMeta({
        canonical: baseUrl,
        robots: ''
      });
    }

    const query = useQuery(this, () => [
      NEWS_INDEX_QUERY,
      { variables: { page, limit } }
    ]);

    try {
      await query.promise;
      const articlesData = query.data.articles || {};

      return {
        articles: articlesData.items || [],
        popularPosts: query.data.popularArticles || [],
        pagination: {
          currentPage: page,
          totalCount: articlesData.totalCount || 0,
          limit: limit,
          hasNextPage: articlesData.hasNextPage || false,
          hasPreviousPage: articlesData.hasPreviousPage || false
        }
      };
    } catch (error) {
      console.error('Error loading news:', error);
      return {
        articles: [],
        popularPosts: [],
        pagination: {
          currentPage: 1,
          totalCount: 0,
          limit: limit,
          hasNextPage: false,
          hasPreviousPage: false
        }
      };
    }
  }
}
